import {faEye,faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState,useEffect,useContext } from 'react';
import {useNavigate} from 'react-router-dom';
import UserService from '../../services/UserService';
import {AuthContext} from './../../Auth/AuthProvider';
export default function Register() {
  const [passwordVisibility,setPasswordVisibility] = useState(false);
  const [userData,setUserData] = useState({});
  const navigator = useNavigate();
  const [openPopUpVisibility,setOpenPopUpVisibility] = useState(false);
  const [errors,setErrors] = useState({});
  const [OTP,setOTP] = useState("");
  const auth = useContext(AuthContext);
  const [OTPVerified,setOTPVerified] = useState(false);
  const [errorBackend,setErrorBackend] = useState("");
  const updateUserData = (e) => {
    setUserData(prev=>({
      ...prev,
      [e.target.name]:e.target.value,
    }));
    setErrors(prev=>({
      ...prev,
      [e.target.name]:false,
    }));
  }
  useEffect(()=>{
    auth.getData();
    if(Object.keys(auth.userData).length >0) {
      navigator("/");
    }
  });
  const sendOTP = () => {
    UserService.generateOTP(userData).then(()=>{
      setOpenPopUpVisibility(true);
    }).catch((err)=>{
      setErrorBackend(err.response.data.errorBackend);
    })
  }
  const validateOTP = () => {
    const OTPData = {
      email:userData.email,
      password:OTP
    }
    UserService.validateEmail(OTPData).then(()=>{
      setOTPVerified(true);
      setOpenPopUpVisibility(false);
    }).catch((err)=>{
      setOpenPopUpVisibility(false);
      setErrorBackend(err.response.data.errorMessage);
    })
  }
  const registerUser = () => {
    const currentError = {};
    if(!userData.firstName || userData.firstName === "") currentError.firstName = true;
    if(!userData.lastName || userData.lastName === "") currentError.lastName = true;
    if(!userData.email || userData.email === "") currentError.email = true;
    if(!userData.userName || userData.userName === "") currentError.userName = true;
    if(!userData.password || userData.password === "") currentError.password = true;
    if(!userData.confirmPassword || userData.confirmPassword === "") currentError.confirmPassword = true;
    if(userData.password !== userData.confirmPassword) {
      currentError.confirmPassword = true;
      currentError.password = true;
    }
    setErrors(currentError);
    if(Object.keys(currentError).length === 0) {
      UserService.register(userData).then((res)=>{
        navigator("/users/login");
      }).catch((err)=>{
        setErrorBackend(err.response.data.errorMessage);
      })
    }
  }
  return (
    <>
      <div className="flex flex-col font-bold dark:bg-neutral-700 items-center w-full max-w-lg m-auto justify-center min-h-[60vh] overflow-hidden bg-amber-50 shadow-lg p-4 sm:p-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-black dark:text-white mb-4 sm:mb-6 text-center">Register</h2>
        <form className="w-full bg-white dark:bg-neutral-800 rounded-lg shadow p-4 sm:p-6 space-y-4 sm:space-y-5">
          <div className="w-full bg-red-800 text-red-400 text-3xl text-center">
            {errorBackend}
          </div>
          <div>
            <label className="block text-black dark:text-white font-semibold mb-1 sm:mb-2" htmlFor="title">
              First Name
            </label>
            <input type="text" id="firstName" name="firstName" onChange={updateUserData} placeholder="enter your first name" className={`border ${errors.firstName? 'border-red-300' : 'border-amber-300'} dark:bg-gray-600 dark:text-white bg-white w-full px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-amber-400`}/>
          </div>
          <div>
            <label className="block text-black dark:text-white font-semibold mb-1 sm:mb-2" htmlFor="title">
              Last Name
            </label>
            <input type="text" id="lastName" name="lastName" onChange={updateUserData} placeholder="enter your last name" className={`border ${errors.lastName? 'border-red-300' : 'border-amber-300'} dark:bg-gray-600 dark:text-white bg-white w-full px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-amber-400`}/>
          </div>
          <div>
            <label className="block text-black dark:text-white font-semibold mb-1 sm:mb-2" htmlFor="title">
              Email
            </label>
            <div className="flex flex-row">
              <input type="text" id="email" name="email" onChange={updateUserData} placeholder="enter your Email ID" className={`w-[80%] border ${errors.email? 'border-red-300' : 'border-amber-300'} dark:bg-gray-600 dark:text-white bg-white w-full px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-amber-400`}/>
              <button type="button" onClick={sendOTP} className={`${OTPVerified? 'bg-green-700 hover:cursor-no-drop' : 'bg-amber-600 hover:bg-amber-700 '} w-[20%] text-white flex items-center justify-center px-2`}>
                {OTPVerified? 'Verified' : 'verify'}
              </button>
            </div>
          </div>
          <div>
            <label className="block text-black dark:text-white font-semibold mb-1 sm:mb-2" htmlFor="title">
              User Name
            </label>
            <input type="text" id="userName" name="userName" onChange={updateUserData} placeholder="enter your user name" className={`border ${errors.userName? 'border-red-300' : 'border-amber-300'} dark:bg-gray-600 dark:text-white bg-white w-full px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-amber-400`}/>
          </div>
          <div>
            <label className="block text-black dark:text-white font-semibold mb-1 sm:mb-2" htmlFor="title">
              Password
            </label>
            <div className="flex flex-row">
              <input type={`${passwordVisibility? 'text' : 'password'}`} id="password" name="password" onChange={updateUserData} placeholder="enter your Password" className={`w-[90%] border ${errors.password? 'border-red-300' : 'border-amber-300'} dark:bg-gray-600 dark:text-white bg-white px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-amber-400`}/>
              <div className="bg-amber-600 hover:bg-amber-700 w-[10%] text-white flex items-center justify-center">
                <FontAwesomeIcon icon={passwordVisibility? faEye : faEyeSlash} onClick={()=>setPasswordVisibility(prev=>!prev)} className="text-2xl hover:cursor-pointer" />
              </div>
            </div>
          </div>
          <div>
            <label className="block text-black dark:text-white font-semibold mb-1 sm:mb-2" htmlFor="title">
              Confirm Password
            </label>
            <input type="password" id="confirmPassword" name="confirmPassword" onChange={updateUserData} placeholder="enter your Confirm Password" className={`border ${errors.confirmPassword? 'border-red-300' : 'border-amber-300'} dark:bg-gray-600 dark:text-white bg-white   w-full px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-amber-400`}/>
          </div>
          <button type="button" onClick={registerUser} className="w-full bg-amber-600 hover:bg-amber-700 text-white font-bold py-2 px-4 rounded transition">
            Sign Up
          </button>
        </form>
      </div>
      {openPopUpVisibility && (
        <div className="fixed font-bold inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-lg p-6 w-full max-w-xs flex flex-col items-center">
            <h3 className="text-lg font-bold mb-4 text-black dark:text-white">Verify OTP</h3>
            <input type="text" maxLength={6} onChange={(e)=>setOTP(e.target.value)} placeholder="Enter OTP" className="mb-4 px-4 py-2 border border-amber-300 rounded w-full focus:outline-none focus:ring-2 focus:ring-amber-400 dark:bg-gray-600 dark:text-white" />
            <div className="flex gap-2 w-full">
              <button type="button" className="flex-1 bg-amber-600 hover:bg-amber-700 text-white font-semibold py-2 rounded transition" onClick={()=> validateOTP()}>
                Verify
              </button>
              <button type="button" className="flex-1 bg-gray-300 hover:bg-gray-400 text-black font-semibold py-2 rounded transition" onClick={() => setOpenPopUpVisibility(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
